import { createSlice } from '@reduxjs/toolkit';
import {
  getDashboardAccepted,
  getDashboardArrived,
  getDashboardClarification,
  getDashboardTesting,
} from './asyncDashboard';

const initialState = {
  isLoading: true,
  isError: null,
  reload: 0,
  dataAccepted: {},
  dataArrived: {},
  dataTesting: {},
  dataClarification: {},
};

export const DASHBOARD_SLICE = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardAccepted.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getDashboardAccepted.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.dataAccepted = payload ?? {};
      })
      .addCase(getDashboardAccepted.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getDashboardArrived.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getDashboardArrived.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.dataArrived = payload ?? {};
      })
      .addCase(getDashboardArrived.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getDashboardTesting.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getDashboardTesting.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.dataTesting = payload ?? {};
      })
      .addCase(getDashboardTesting.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getDashboardClarification.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getDashboardClarification.fulfilled, (state, { payload }) => {
        if (!payload?.data) {
          state.dataClarification = {};
          state.isLoading = false;
          return;
        }
        const tempArr = [];
        (payload.data || []).forEach((item) => {
          tempArr.push({
            rmaNumber: item.number,
            customerId: item.debitor?.id,
            rmaId: item?.id,
            articlesLength: item.articles?.length ?? 0,
            clarificationText: item.clarificationText,
          });
        })
        state.dataClarification = { resultsRmas: tempArr, lengthAllClarificationRmas: payload?.meta?.pagination?.total };
        state.isLoading = false;
      })
      .addCase(getDashboardClarification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

// Action creators are generated for each case reducer function
export const { } = DASHBOARD_SLICE.actions;

export default DASHBOARD_SLICE.reducer;
